import {
  Button,
  Col,
  ConfigProvider,
  Image,
  Input,
  Layout,
  Pagination,
  Row,
  Switch,
  Table,
  message,
} from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import OAMSider from '../oam-sider'
import { Content } from 'antd/lib/layout/layout'
import { sendHttpPostRequest } from '@/api/http-request'
import { render } from '@testing-library/react'
import idataCourseTableStyles from '../../common/global-styles/idatacoding.module.less'
import zhCN from 'antd/es/locale/zh_CN'
import * as constants from '../../../constants/constants'
import { useHistory } from 'react-router-dom'
import ModalDrag from '@/pages/components/ModaDrag/ModalDrag'
import GlobalCss from '@/global.module.less'

const { Search } = Input

function OAMLogoManageList() {
  const page = useRef(1)
  const pageSize = useRef(10)
  const queryContent = useRef('')
  const history = useHistory()
  const [logoList, setLogoList] = useState([] as any)
  const [resultSum, setResultSum] = useState(0)
  const [actionLogo, setActionLogo] = useState<any>()
  const [deleLogoModalVis, setDeleLogoModalVis] = useState(false)

  const getLogoList = () => {
    let data = {
      page: page.current,
      page_size: pageSize.current,
      query: queryContent.current,
    }

    sendHttpPostRequest('course/api/oam_logo_list', data, (res) => {
      if (res.code == 0) {
        setLogoList(res.data.list)
        setResultSum(res.data.page_info.total_count)
      } else {
        message.error(res.msg)
      }
    })
  }

  const onPageChange = (np, nps) => {
    ;(page.current = np), (pageSize.current = nps)
    getLogoList()
  }

  const deleteOk = () => {
    let data = {
      logo_id: actionLogo.id,
    }

    sendHttpPostRequest('course/api/oam_delete_logo', data, (res) => {
      if (res.code == 0) {
        message.success('删除成功')
        getLogoList()
      } else {
        message.error(res.msg)
      }
    })
    setDeleLogoModalVis(false)
  }

  useEffect(() => {
    getLogoList()
  }, [])

  //点击了搜索按钮
  const onSearchBtn = (value: string) => {
    page.current = 1
    queryContent.current = value
    getLogoList()
  }

  // 上线

  const putStatusOnline = (id) => {
    let data = {
      logo_id: id,
    }
    sendHttpPostRequest('course/api/oam_online_logo', data, (res) => {
      if (res.code == 0) {
        message.success('上线成功~')
        getLogoList()
      } else {
        message.error(res.msg)
      }
    })
  }

  // 下线
  const putStatusOffline = (id) => {
    let data = {
      logo_id: id,
    }
    sendHttpPostRequest('course/api/oam_offline_logo', data, (res) => {
      if (res.code == 0) {
        message.success('下线成功~')
        getLogoList()
      } else {
        message.error(res.msg)
      }
    })
  }

  const onStatusChange = (r, checked: boolean) => {
    console.log(`switch to ${checked}`, r)
    if (checked && r.status == 0) {
      // 上线logo接口
      putStatusOnline(r.id)
    } else if (!checked && r.status == 1) {
      // 下线logo接口
      putStatusOffline(r.id)
    }
  }

  const onEditBtnClick = (r) => {
    history.push('/oam_logo_edit/' + r.id)
  }

  // 表格列
  const cols: any = [
    {
      title: '序号',
      dataIndex: 'user_id',
      key: 'user_id',
      width: 50,
      align: 'left',
      render: (text, record, index) =>
        (page.current - 1) * pageSize.current + index + 1,
    },
    {
      title: '背景图',
      dataIndex: 'image_path',
      key: 'image_path',
      width: 160,
      align: 'left',
      render: (t, r, i) => {
        return (
          <Image width={156} height={36} src={constants.BACKEND_API_URL + t} />
        )
      },
    },
    {
      title: '名称',
      dataIndex: 'name',
      key: 'name',
      width: 200,
      align: 'left',
      ellipsis: true,
    },
    {
      title: '名称样式',
      dataIndex: 'style',
      key: 'style',
      width: 200,
      align: 'left',
      ellipsis: true,
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      width: 100,
      align: 'left',
      render: (t, r, i) => (t == 1 ? '已上线' : '已下线'),
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      width: 200,
      fixed: 'right',
      align: 'center',
      render: (t, r, i) => (
        <Row
          justify="center"
          align="middle"
          style={{ gap: '4px' }}
          wrap={false}
        >
          <Col>
            <Switch
              checked={r.status == 0 ? false : true}
              onChange={(checked) => onStatusChange(r, checked)}
            />
          </Col>
          <Col>
            <Button
              style={{ borderRadius: 20, fontSize: 12 }}
              size="small"
              id="edit"
              type="dashed"
              onClick={() => onEditBtnClick(r)}
            >
              {' '}
              编 辑{' '}
            </Button>
          </Col>
          <Col>
            <Button
              style={{ borderRadius: 20, fontSize: 12 }}
              size="small"
              id="delete"
              danger
              onClick={() => {
                setActionLogo(r)
                setDeleLogoModalVis(true)
              }}
            >
              {' '}
              删 除{' '}
            </Button>
          </Col>
        </Row>
      ),
    },
  ]

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <OAMSider keys={'logo—manager'} openKeys={[]}></OAMSider>
      <Layout style={{ backgroundColor: '#f9f9f9' }}>
        <Content
          style={{
            backgroundColor: '#fff',
            borderRadius: 5,
            minWidth: 400,
            margin: 30,
            paddingTop: 20,
          }}
        >
          <Row
            justify="space-between"
            align="middle"
            style={{ paddingLeft: 30, paddingRight: 30 }}
          >
            <Col>
              <div className={'css.search1'}>
                <Search
                  placeholder="请输入名称搜索"
                  style={{ width: 350 }}
                  enterButton={true}
                  onSearch={onSearchBtn}
                />
              </div>
            </Col>
            <Col>
              <Button
                style={{
                  borderRadius: 27,
                }}
                type="primary"
                onClick={() => history.push('/oam_logo_create')}
              >
                + 新 建
              </Button>
            </Col>
          </Row>
          <div
            className={GlobalCss.tableWrapper}
            style={{padding: 30}}
          >
            <ConfigProvider locale={zhCN}>
              <Table
                dataSource={logoList}
                columns={cols}
                rowKey={(record) => record.user_id}
                pagination={false}
                scroll={{ x: 800 }}
              />
            </ConfigProvider>
          </div>

          <ConfigProvider locale={zhCN}>
            <div
              style={{ marginBottom: 30, paddingTop: 30, textAlign: 'center' }}
              className={'css.pagination'}
            >
              <Pagination
                defaultCurrent={1}
                total={resultSum}
                hideOnSinglePage={true}
                pageSize={pageSize.current}
                onChange={onPageChange}
                current={page.current}
                showQuickJumper={true}
                showTotal={(total) => `共 ${total} 个logo`}
                pageSizeOptions={['10', '20', '50', '100']}
              />
            </div>
          </ConfigProvider>
          <ModalDrag
            width={450}
            theme={'light'}
            modalTitle={'提示'}
            modalContent={
              <div style={{ textAlign: 'center', height: '60px' }}>
                确定要删除该logo吗？
              </div>
            }
            open={deleLogoModalVis}
            onOk={deleteOk}
            onCancel={() => setDeleLogoModalVis(false)}
          />
        </Content>
      </Layout>
    </Layout>
  )
}

export default OAMLogoManageList
